import React from "react";
import Navbar from "../../../navbar";
import Footer from "../../../footer";
import "./style.scss";
// import IpLocation from "ip-location";
// import axios from "axios";
import SEO from "../../../seo";

import { Link } from "gatsby";

import blogData from "../../../bloginner/data";

// import banner from "../../../../images/memoryfoamvslatexfoam.png";

export default function BenefitsOfBonnellSpring(props) {
  const { location, data } = props;

  //   const { blogImg, blogTitle, content, date, seoDescription, seoImg } = data;

  var prev = null;
  var next = null;

  let i = 0;

  blogData.forEach((item, it) => {
    if (location.pathname.includes(item.link)) {
      i = it;
    }
  });

  if (i === 0) {
    prev = null;
  } else {
    prev = (
      <Link className="blog__bottombuttons__prev" to={blogData[i - 1].link}>
        <i class="fas fa-arrow-left"></i> Prev
      </Link>
    );
  }

  if (i === blogData.length - 1) {
    next = null;
  } else {
    next = (
      <Link className="blog__bottombuttons__next" to={blogData[i + 1].link}>
        Next <i class="fas fa-arrow-right"></i>
      </Link>
    );
  }

  return (
    <div className="blog benefitsofbonnell">
      <SEO
        title={"Benefits of Bonnell Springs | Eclipse International "}
        description={
          "Learn about the most traditional and well-known type of innerspring systems to see if a spring mattress is for you."
        }
        img={""}
      />
      <Navbar />
      <div className="blog__content">
        <h1 className="blog__title">Benefits of Bonnell Spring</h1>
        <div className="blog__header">
          <div className="blog__header__date">November 02, 2021</div>
          <div className="blog__header__socialshare">
            Share&nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </div>
        <img
          className="blog__headerimg blog__headerimg--desktop"
          src={
            "https://eclipsemattress.in/assets/blog/benefitsofbonnellspring-banner-desktop.jpg"
          }
          alt="Blog Header Image"
        ></img>

        <img
          className="blog__headerimg blog__headerimg--mobile"
          src={
            "https://eclipsemattress.in/assets/blog/benefitsofbonnellspring-banner-mobile.jpg"
          }
          alt="Blog Header Image"
        ></img>

        <div className="blog__container">
          <p>
            Shortcut to quality life? Good Sleep.
            <br />
            <br />
            But the road to good sleep can be bumpy if you choose the wrong
            mattress! Bonnell Spring mattresses can help you achieve the smooth
            sleeping experience that you deserve.
            <br />
            <br />
            Also known as open coil spring mattresses, Bonnell Springs are one
            of the most traditional and well-known types of innerspring mattress
            systems.
            <br />
            <br />
            These hourglass -shaped steel wire coils unified using a metal wire.
            The springs move in tandem, offering a solid, sturdy structure and
            consistent support – great for sleepers that like comfortably
            rolling and turning!
          </p>

          <br />
          <br />

          <div className="row">
            <div className="col col-12 col-xl-6">
              <div className="benefitsofbonnell__card">
                <img src="https://eclipsemattress.in/assets/blog/bonnellspringicon1.png"></img>
                <div>
                  <h4>Firm & Solid</h4>
                  <p>
                    Being an interconnected mesh of spring coils, the Bonnell
                    spring system gives consistent support throughout the bed
                    surface. The firmness of the mattress gives a solid support
                    to the body.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-12 col-xl-6">
              <div className="benefitsofbonnell__card">
                <img src="https://eclipsemattress.in/assets/blog/bonnellspringicon2.png"></img>
                <div>
                  <h4>Zero Sagging</h4>
                  <p>
                    The innerspring coils wound together support each other and
                    prevent sagging. The surface stays flat despite any amount
                    of pressure and this helps prevent sagging and deterioration
                    of the internal springs and layers of foam.
                  </p>
                </div>
              </div>
            </div>

            <div className="col col-12 col-xl-6">
              <div className="benefitsofbonnell__card">
                <img src="https://eclipsemattress.in/assets/blog/bonnellspringicon3.png"></img>
                <div>
                  <h4>Durable</h4>
                  <p>
                    The springs provide uniform support throughout the mattress
                    irrespective of body weight and the number of people
                    sleeping on it. Bonnell spring mattresses last for upto 10
                    years.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-12 col-xl-6">
              <div className="benefitsofbonnell__card">
                <img src="https://eclipsemattress.in/assets/blog/bonnellspringicon4.png"></img>
                <div>
                  <h4>Provide Steady Back Support</h4>
                  <p>
                    This spring system particularly helps elevate & align the
                    spine and surrounding muscles together, providing a steady
                    support to the back. Excellent for old or overweight people
                    who have a curvy or delicate body structure.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p>
            Explore Eclipse's range of spring mattresses developed with premium
            heavy gauge Bonnell Springs{" "}
            <a href="/spring-mattress/bonnell-spring/">here</a>.
          </p>
        </div>

        <center>
          <div className="blog__header__socialshare">
            Share &nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </center>

        <div className="blog__bottombuttons">
          {prev} {next}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}
